import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['success', 'error']).isRequired,
};

const defaultProps = {};

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '13px',
      marginRight: theme.spacing(0.5),
    },
  },
  typography: {
    fontSize: '12px',
  },
  success: {
    color: theme.palette.type === 'light' ? '#2E7D32' : theme.palette.success.dark,
  },
  error: {
    color: theme.palette.type === 'light' ? '#C41212' : theme.palette.error.dark,
  },
}));

function FormAlert({ children, variant }) {
  const classes = useStyles();
  const icon = variant === 'success' ? <CheckCircleIcon /> : <CancelIcon />;

  return (
    <Box
      className={clsx(classes.container, {
        [classes.success]: variant === 'success',
        [classes.error]: variant === 'error',
      })}
    >
      {icon}
      <Typography className={classes.typography} component="div">
        {children}
      </Typography>
    </Box>
  );
}

FormAlert.propTypes = propTypes;
FormAlert.defaultProps = defaultProps;

export default FormAlert;
